import { Flex, Heading, HStack, Text, useTheme, VStack } from '@chakra-ui/react'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ButtonSelectorList from '../../../components/ButtonSelectorList/ButtonSelectorList'
import UnderLine from '../../../components/UnderLine/UnderLine'
import useButtonSelector from '../../../utils/hooks/useButtonSelector/useButtonSelector'
import { useLabels } from '../../../utils/hooks/useLabels/useLabels'

const options = [
  { label: 'Individual', icon: faCheckCircle, to: 'individual' },
  { label: 'Masivo', icon: faCheckCircle, to: 'massive' },
]

export default function PartnerRegister() {
  const { texts } = useLabels()
  const { colors } = useTheme()
  const navigate = useNavigate()
  const { selected, onSelectedChange } = useButtonSelector(options)
  useEffect(() => {
    if (selected.to) {
      navigate(selected.to)
    }
  }, [navigate, selected])
  return (
    <Flex
      direction="column"
      h="80vh"
      justifyContent="center"
      alignItems="center"
    >
      <VStack alignItems="center" justifyContent="center">
        <Heading variant="h5">{texts.register_collaborator_type}</Heading>
        <UnderLine />
      </VStack>
      <ButtonSelectorList
        stackProps={{
          mt: '45px',
          spacing: '29px',
        }}
        options={options}
        selected={selected}
        onSelectedChange={onSelectedChange}
      />
      <HStack
        mt="104px"
        borderRadius="16px"
        p="8px"
        _hover={{
          cursor: 'pointer',
          bgColor: colors.gray[50],
        }}
        onClick={() => navigate(-1)}
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        <Text variant="semibold">{texts.back_account_creation}</Text>
      </HStack>
    </Flex>
  )
}
